import React, { useState, useMemo } from "react";
import { Menu } from "antd";
import Icon from "../Icon";
import PropTypes from "prop-types";
import classnames from "classnames";
import { UiStretchMenuLayout } from "./StretchMenuLayout.style";
/**
 * 多了一層menu可選的layout
 */

const {
  SubMenu,
  Item
} = Menu;

const StretchMenuLayout = ({
  header,
  sidebar,
  children,
  title,
  env,
  version = "localhost"
}) => {
  const [isShow, setState] = useState(false);

  const toggleSidebar = () => {
    setState(!isShow);
  };

  const urlGroup = useMemo(() => {
    const resourceLibrary = `https://resource-library${env !== "release" ? `-${env}` : ""}.oneclass.com.tw/`;
    const tiku = `https://question-bank${env !== "release" ? `-${env}` : ""}.oneclass.com.tw/`;
    return {
      resourceLibrary,
      tiku
    };
  }, [env]);
  return /*#__PURE__*/React.createElement(UiStretchMenuLayout, null, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("i", {
    className: "material-icons",
    onClick: () => toggleSidebar()
  }, isShow ? "close" : "menu"), header), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames("mark", isShow && "active")
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames("stretchMenu", isShow && "active")
  }, /*#__PURE__*/React.createElement("div", {
    className: "linkContainer"
  }, /*#__PURE__*/React.createElement(Menu, {
    defaultSelectedKeys: ["1"],
    mode: "inline"
  }, /*#__PURE__*/React.createElement(Item, {
    key: "publicCode",
    icon: /*#__PURE__*/React.createElement(Icon, {
      name: "grid_on"
    })
  }, /*#__PURE__*/React.createElement("a", {
    href: `${urlGroup.resourceLibrary}publicCode?type=year`
  }, "\u5171\u7528\u4EE3\u78BC")), /*#__PURE__*/React.createElement(Item, {
    key: "subject",
    icon: /*#__PURE__*/React.createElement(Icon, {
      name: "domain_verification"
    })
  }, /*#__PURE__*/React.createElement("a", {
    href: `${urlGroup.resourceLibrary}subject`
  }, "\u79D1\u76EE\u8CC7\u6599")), /*#__PURE__*/React.createElement(SubMenu, {
    key: "chapter",
    title: "\u7AE0\u7BC0\u8CC7\u6599",
    icon: /*#__PURE__*/React.createElement(Icon, {
      name: "list_alt"
    })
  }, /*#__PURE__*/React.createElement(Menu.Item, {
    key: "chapter"
  }, /*#__PURE__*/React.createElement("a", {
    href: `${urlGroup.resourceLibrary}chapter`
  }, "\u8AB2\u672C\u7AE0\u7BC0")), /*#__PURE__*/React.createElement(Menu.Item, {
    key: "all",
    disabled: true
  }, /*#__PURE__*/React.createElement("a", {
    href: `${urlGroup.resourceLibrary}publicCode?type=year`
  }, "\u7E3D\u8907\u7FD2\u7AE0\u7BC0"))), /*#__PURE__*/React.createElement(Item, {
    key: "product",
    icon: /*#__PURE__*/React.createElement(Icon, {
      name: "pageview",
      type: "outLined"
    }),
    disabled: true
  }, "\u7522\u54C1\u67E5\u8A62"), /*#__PURE__*/React.createElement(Item, {
    key: "tiku",
    icon: /*#__PURE__*/React.createElement(Icon, {
      name: "eco",
      type: "outLined"
    })
  }, /*#__PURE__*/React.createElement("a", {
    href: urlGroup.tiku
  }, "\u984C\u5EAB")), /*#__PURE__*/React.createElement(Item, {
    key: "book",
    icon: /*#__PURE__*/React.createElement(Icon, {
      name: "chrome_reader_mode",
      type: "outLined"
    }),
    disabled: true
  }, "\u96FB\u5B50\u66F8"))))), /*#__PURE__*/React.createElement("div", {
    className: "sidebar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, title), sidebar, /*#__PURE__*/React.createElement("div", {
    className: "version"
  }, version)), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "scroll"
  }, children))));
};

export default StretchMenuLayout;
StretchMenuLayout.propTypes = {
  title: PropTypes.node,
  header: PropTypes.element,
  sidebar: PropTypes.element,
  children: PropTypes.node,
  env: PropTypes.string,
  version: PropTypes.string
};